import React, { Fragment, useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import PerfectScrollbar from 'react-perfect-scrollbar';

import {
    TextField,
    Avatar,
    Icon,
    Tooltip,
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    Box,
    Button,
    IconButton,
    Grid,
    colors,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Link
} from '@material-ui/core';


import EditRoundedIcon from '@material-ui/icons/EditRounded';
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import Add from '@material-ui/icons/AddCircleOutline';

import { AiOutlineLineChart } from "react-icons/ai";


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 350,
        minHeight: 350
    },
    avatar: {
        marginRight: theme.spacing(2),
        backgroundColor: colors.grey[200]
    },
    fieldset: {
        margin: 15
    },
    btnadd: {
        marginBottom: 10
    }
}));

const Field = ({ item, closeEdition, updateValues, open, openTestEdition, openTestDeletion, test }) => {

    const classes = useStyles();

    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="lg" >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Porta de Entrada Número {item.order}
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Box
                        display="flex"
                        flexDirection="column"
                        height="100%"
                        justifyContent="center"
                    >
                        <Formik
                            initialValues={item}
                            validationSchema={
                                Yup.object().shape({
                                    order: Yup.string().max(255).required('Ordem é obrigatória'),
                                    name: Yup.string().max(255).required('Nome é obrigatório'),
                                    unit: Yup.string().max(255).required('Unidade é obrigatório'),
                                    format: Yup.string().max(255).required('Formato é obrigatório'),
                                    sufix: Yup.string().max(255).required('Sufixo é obrigatório')
                                })
                            }
                            onSubmit={(values, formik) => {
                                updateValues(values);
                                formik.setSubmitting(false);
                            }}
                        >
                            {({
                                errors,
                                handleBlur,
                                handleChange,
                                handleSubmit,
                                isSubmitting,
                                touched,
                                values
                            }) => (
                                <form onSubmit={handleSubmit}>

                                    <Grid
                                        container
                                        alignItems="flex-end"
                                        spacing={2}
                                    >
                                        <Grid
                                            item
                                            md={1}
                                            xs={12}>
                                            <TextField
                                                error={Boolean(touched.order && errors.order)}
                                                fullWidth
                                                helperText={touched.order && errors.order}
                                                label="Ordem"
                                                margin="normal"
                                                name="order"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.order}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            md={4}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.name && errors.name)}
                                                fullWidth
                                                helperText={touched.name && errors.name}
                                                label="Nome"
                                                margin="normal"
                                                name="name"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.name}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>

                                            <TextField
                                                error={Boolean(touched.unit && errors.unit)}
                                                fullWidth
                                                helperText={touched.unit && errors.unit}
                                                label="Unidade"
                                                margin="normal"
                                                name="unit"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.unit}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>
                                            <TextField
                                                error={Boolean(touched.format && errors.format)}
                                                fullWidth
                                                helperText={touched.format && errors.format}
                                                label="Formato"
                                                margin="normal"
                                                name="format"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.format}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            md={1}
                                            xs={12}>
                                            <TextField
                                                error={Boolean(touched.sufix && errors.sufix)}
                                                fullWidth
                                                helperText={touched.sufix && errors.sufix}
                                                label="Sufixo"
                                                margin="normal"
                                                name="sufix"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.sufix}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>

                                        <Grid
                                            item
                                            md={2}
                                            xs={12}>
                                            <Button
                                                color="secondary"
                                                className={classes.btnadd}
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                startIcon={<Add />}
                                                onClick={() => { openTestEdition(test) }}>
                                                Criar Monitor
                                            </Button>
                                        </Grid>

                                    </Grid>
                                    <br></br>
                                    <TableContainer component={PerfectScrollbar}>

                                        <Table stickyHeader size="small" aria-label="a dense table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>
                                                        Monitor
                                                    </TableCell>
                                                    <TableCell>
                                                        Condição
                                                    </TableCell>
                                                    <TableCell>
                                                        Resultado
                                                    </TableCell>
                                                    <TableCell>
                                                        Reportar
                                                    </TableCell>
                                                    <TableCell>
                                                        Habilitado
                                                    </TableCell>
                                                    <TableCell>
                                                    </TableCell>
                                                    <TableCell>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {(values.tests.length > 0) ?
                                                    (values.tests.map((test, index) => (
                                                        <TableRow hover key={test.id} >
                                                            <TableCell>
                                                                <Box alignItems="center"
                                                                    display="flex"
                                                                    component={Link}
                                                                    onClick={() => { openTestEdition(test) }}
                                                                >
                                                                    <Avatar
                                                                        className={classes.avatar}
                                                                    >
                                                                        {<Icon component={AiOutlineLineChart} style={{ color: colors.indigo[400] }} ></Icon>}
                                                                    </Avatar>
                                                                    {test.name}
                                                                </Box>
                                                            </TableCell>

                                                            <TableCell>
                                                                {test.description}
                                                            </TableCell>

                                                            <TableCell>
                                                                {(test.rule) ? test.rule.event.params.msg : ''}
                                                            </TableCell>

                                                            <TableCell>
                                                                {(test.rule) ? (test.rule.event.type === 'fail') ? 'Falha' : 'Atenção' : ''}
                                                            </TableCell>

                                                            <TableCell>
                                                                {(test.enabled ? 'Sim' : 'Não')}
                                                            </TableCell>

                                                            <TableCell >
                                                                <Tooltip title="Editar monitor do campo de entrada">
                                                                    <IconButton
                                                                        color="secondary"
                                                                        className={classes.btntreatment}
                                                                        children={<EditRoundedIcon />}
                                                                        size="medium"
                                                                        onClick={() => { openTestEdition(test) }}>
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </TableCell>

                                                            <TableCell >
                                                                <Tooltip title="Excluir monitor do campo de entrada">
                                                                    <IconButton
                                                                        color="secondary"
                                                                        className={classes.btntreatment}
                                                                        children={<DeleteRoundedIcon />}
                                                                        size="medium"
                                                                        onClick={() => { openTestDeletion(test) }}>
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </TableCell>

                                                        </TableRow>
                                                    ))) : (
                                                        <TableRow >
                                                            <TableCell colSpan={6} >Nenhum Monitor Registrado para o Campo</TableCell>
                                                        </TableRow>
                                                    )
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>


                                    <Box my={1}></Box>
                                    <Divider />

                                    <Box my={1}>
                                        <Grid container
                                            direction="row"
                                            justify="flex-end"
                                            alignItems="baseline"
                                            spacing={1}  >
                                            <Grid item >
                                                <Button
                                                    color="secondary"
                                                    disabled={isSubmitting}
                                                    size="small"
                                                    type="submit"
                                                    variant="contained">
                                                    Salvar
                                                </Button>
                                            </Grid>
                                            <Grid item >
                                                <Button
                                                    color="secondary"
                                                    disabled={isSubmitting}
                                                    size="small"
                                                    variant="contained"
                                                    onClick={() => { closeEdition() }}>
                                                    Cancelar
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Box>

                                </form>
                            )}
                        </Formik>
                    </Box>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Field;
